<template>
  <v-row justify="start">
    <v-col v-if="legend.includes('not-exact')" cols="auto">
      <v-icon size="20" color="red">mdi-alert-octagram-outline</v-icon>
      <span style="font-size: 13px; color: red">{{
        mess.legend_not_exact
      }}</span>
    </v-col>
    <v-col v-if="legend.includes('assembly')" cols="auto">
      <v-icon size="18">widgets</v-icon>
      <span style="font-size: 13px">{{ mess.legend_assembly }}</span>
    </v-col>
    <v-col v-if="legend.includes('have-analog')" cols="auto">
      <v-icon size="18">mdi-content-copy</v-icon>
      <span style="font-size: 13px">{{ mess.legend_analog }}</span>
    </v-col>
    <v-col v-if="legend.includes('on-store')" cols="auto">
      <v-icon size="19">mdi-warehouse</v-icon>
      <span style="font-size: 13px">{{ mess.legend_item_on_store }}</span>
    </v-col>
    <v-col v-if="legend.includes('analog-on-store')" cols="auto">
      <v-icon size="19">mdi-check-box-multiple-outline</v-icon>
      <span style="font-size: 13px">{{ mess.legend_analog_on_store }}</span>
    </v-col>
    <v-col v-if="legend.includes('in-transit')" cols="auto">
      <v-icon size="19">mdi-ferry</v-icon>
      <span style="font-size: 13px">{{ mess.legend_transit }}</span>
    </v-col>
    <v-col v-if="legend.includes('sales-draw')" cols="auto">
      <v-icon size="19">mdi-android-studio</v-icon>
      <span style="font-size: 13px">{{ mess.legend_sales_draft }}</span>
    </v-col>
    <v-col v-if="legend.includes('file')" cols="auto">
      <v-icon size="19" style="transform: rotate(90deg)">mdi-attachment</v-icon>
      <span style="font-size: 13px">{{ mess.legend_file }}</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ArticleLegend",
  props: {
    legend: {
      type: Array,
      default: () => [
        "assembly",
        "have-analog",
        "on-store",
        "analog-on-store",
        "in-transit",
        "sales-draw"
      ]
    }
  }
};
</script>

<style lang="scss" scoped></style>
